"use strict";
/*
 * Created on 2. 10. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../conversions/DataObjectConverter");
/**
 * {@code OverviewConverter} converter.
 *
 * @author Radek Beran
 */


var OverviewConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(OverviewConverter, _DataObjectConverter_);

  function OverviewConverter() {
    _classCallCheck(this, OverviewConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(OverviewConverter).apply(this, arguments));
  }

  return OverviewConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.OverviewConverter = OverviewConverter;